// Realtor Plugin Event Types
// MQTT events specific to realtor plugin

export const REALTOR_EVENT_TYPES = {
  // Developer events
  DEVELOPER_DELETED: 'developer.deleted',
  
  // Residential complex events
  COMPLEX_DELETED: 'residential_complex.deleted',
  
  // Apartment events
  APARTMENT_DELETED: 'apartment.deleted',
  
  // Feed events
  FEED_DELETED: 'feed.deleted',
  FEED_SYNC_STARTED: 'feed.sync.started',
  FEED_SYNC_COMPLETED: 'feed.sync.completed',
  FEED_SYNC_FAILED: 'feed.sync.failed',
} as const;

export type RealtorEventType = typeof REALTOR_EVENT_TYPES[keyof typeof REALTOR_EVENT_TYPES];

export interface RealtorEvent {
  type: RealtorEventType;
  payload: unknown;
  timestamp: number;
}

// Feed sync event payloads
export interface FeedSyncStartedPayload {
  feedId: string;
  feedName: string;
}

export interface FeedSyncCompletedPayload {
  feedId: string;
  feedName: string;
  stats: {
    created: number;
    updated: number;
    deleted: number;
    errors: number;
  };
}

export interface FeedSyncFailedPayload {
  feedId: string;
  feedName: string;
  error: string;
}

// Delete event payloads
export interface EntityDeletedPayload {
  id: string;
  name?: string;
}
